import { Outlet } from "react-router-dom";

const BreakDownLayout = () => {
  return (
    <><Outlet /></>
  );
};

export default BreakDownLayout;